<template>
  <div>
    <regala-hero />
    <bottom-shape :background="'rgb(103 200 200)'"></bottom-shape>
    <ketarim/>
  </div>
</template>
<script>
import RegalaHero from "./RegalaHero";
import Ketarim from "./Ketarim";
export default {
  components: {
    RegalaHero,
    Ketarim,
  },
};
</script>